export const getKey = (topic: string, keys: string[]) =>
  JSON.stringify({ topic, keys: [...keys].sort() });
